import { render } from "./product-gallery-thumbs.vue?vue&type=template&id=6759166a"
import script from "./product-gallery-thumbs.vue?vue&type=script&lang=js"
export * from "./product-gallery-thumbs.vue?vue&type=script&lang=js"

import "./product-gallery-thumbs.vue?vue&type=style&index=0&id=6759166a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__